<template>
  <div :key="handleDate">
    <Loading v-if="fetchLoading" />
    <router-view :key="$route.fullPath" />
  </div>
</template>
<script>
import Loading from "./components/Loading";
import { computed, onMounted } from "vue";
import { useStore } from "vuex";
export default {
  components: {
    Loading,
  },
  setup() {
    const store = useStore();
    const fetchLoading = computed(() => {
      return store.state.fetchLoading;
    });
    const handleDate = () => {
      return new Date().getTime();
    };
    onMounted(() => {
      handleDate();
    });
    return {
      fetchLoading,
      handleDate,
    };
  },
};
</script>
<style>
@import "assets/css/reset.css";
@import "assets/theme/index.less";

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  min-height: 100vh;
}
</style>
